<template>
  <div class="engleft" id="engleft">
    <div class="engleft_img">
      <img src="../../../../static/pic_zz.png" alt="">
    </div>
    <div class="engleft_img_info">
      <div class="img_info_head">Journal Information</div>
      <div class="infotype">
        <p class="info_tit">Responsible institution</p>
        <p>China Association for Science and Technology</p>
      </div>
      <div class="infotype">
        <p class="info_tit">Sponsor</p>
        <p>Chinese Medical Association</p>
        <!-- <p>42 Dongsi Xidajie，Beijing 100710，China</p> -->
      </div>
      <div class="infotype">
        <p class="info_tit">Editing</p>
        <p>Editorial Board of Chinese Journal of Digestive Surgery</p>
        <!-- <p>42 Dongsi Xidajie，Beijing 100710，China</p>
        <p>Tel: 0086-10-85158174</p>
        <p>Fax: 0086-10-85158180</p>
        <p>Email: digsurg@zhxhwk.com</p> -->
        <p>http://www.medline.org.cn</p>
      </div>
      <div class="infotype">
        <p class="info_tit">Editor-in-Chief</p>
        <p>Dong Jiahong（董家鸿）</p>
      </div>
      <div class="infotype">
        <p class="info_tit">Executive Deputy Editor-in-Chief</p>
        <p>Chen Min（陈敏）</p>
      </div>
      <div class="infotype">
        <p class="info_tit">Publishing</p>
        <p>Chinese Medical Journals Publishing House Co.，Ltd.</p>
        <!-- <p>42 Dongsi Xidajie，Beijing 100710，China</p>
        <p>Tel（fax）：0086-10-85158180</p>
        <p>Email：office@cma.org.cn</p> -->
      </div>
      <div class="infotype">
        <p class="info_tit">Overseas Distributor</p>
        <p>China International Book Trading Corportation</p>
      </div>
    </div>
    <div class="engleft_substr">
      <div class="subst_head">Indexed by</div>
      <vue-seamless-scroll :data="accodrdingList" class="seamless-warp" :class-option="classOption">
        <ul>
          <li v-for="(item,index) in accodrdingList" :key="index">
            <a :href="item.SiteUrl" target="_blank">
              <span v-html="item.SiteName"></span>
            </a>
          </li>
        </ul>
      </vue-seamless-scroll>
    </div>
  </div>
</template>
<script>
import vueSeamlessScroll from 'vue-seamless-scroll'
import axios from 'axios'
export default {
  data(){
    return{
      accodrdingList:[
        {
          Linkurl:'',
          Title:'China VIP databaseChina VIP databaseChina VIP databaseChina VIP database'
        },
        {
          Linkurl:'',
          Title:'China VIP databaseChina VIP databaseChina VIP databaseChina VIP database'
        },
        {
          Linkurl:'',
          Title:'China VIP databaseChina VIP databaseChina VIP databaseChina VIP database'
        },
        {
          Linkurl:'',
          Title:'China VIP databaseChina VIP databaseChina VIP databaseChina VIP database'
        },
        {
          Linkurl:'',
          Title:'China VIP databaseChina VIP databaseChina VIP databaseChina VIP database'
        },
        {
          Linkurl:'',
          Title:'China VIP databaseChina VIP databaseChina VIP databaseChina VIP database'
        },
        {
          Linkurl:'',
          Title:'China VIP databaseChina VIP databaseChina VIP databaseChina VIP database'
        },
        {
          Linkurl:'',
          Title:'China VIP databaseChina VIP databaseChina VIP databaseChina VIP database'
        },
        {
          Linkurl:'',
          Title:'China VIP databaseChina VIP databaseChina VIP databaseChina VIP database'
        },
        {
          Linkurl:'',
          Title:'China VIP databaseChina VIP databaseChina VIP databaseChina VIP database'
        },
      ]
    }
  },
  methods: {
    getadvertCooper(){
      var params = new URLSearchParams();
      params.append('JournalID', 202208020001);  //期刊ID，固定不变
      params.append('ChannelID', 3144);
      axios.post('/FriendlyLinkWebAPI/GetList',params).then((res) => {
        this.accodrdingList = res.data.data
      })
    }
  },
  components:{
    vueSeamlessScroll
  },
  computed:{
    classOption () {
      return {
        step: 0.6, // 数值越大速度滚动越快
        // limitMoveNum: this.accodrdingList.length - 10, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      }
    },
  },
  created() {
    this.getadvertCooper()
  },
}
</script>
<style lang="less" scoped>
  .engleft{
    width:290px;
    .engleft_img{
      width: 290px;
      border: 1px solid #ddd;
      padding: 5px 0;
      img{
        width: 270px;
        position: relative;
        top: 2px;
        left: 9px;
      }
    }
    .engleft_img_info{
      padding: 8px;
      border:1px solid #ddd;
      margin-top: 18px;
      .img_info_head{
        line-height: 35px;
        border-bottom: 1px solid #ddd;
        font-size: 18px;
        color: #b80000;
        font-weight: bold;
      }
      .infotype{
        margin-top: 12px;
        .info_tit{
          font-weight: bold;
          font-size: 14px;
          color: #000;
        }
        p{
          font-size: 14px;
          color: #000;
          margin-bottom: 5px;
          text-align: justify;
        }
      }
    }
    .engleft_substr{
      padding: 8px;
      border:1px solid #ddd;
      margin-top: 18px;
      .subst_head{
        line-height: 35px;
        border-bottom: 1px solid #ddd;
        font-size: 18px;
        color: #b80000;
        font-weight: bold;
      }
      .seamless-warp{
        height: 300px;
        padding: 10px 6px 13px 6px;
        overflow: hidden;
        ul{
          width: 100%;
          height: auto;
          li{
            width: 100%;
            margin-bottom:12px;
            text-overflow:ellipsis;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
            border-bottom: 1px solid #ddd;
            padding-bottom: 5px;
            span{
              width: 100%;
              overflow: hidden;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              line-clamp: 2;
              -webkit-box-orient: vertical;
              font-size: 14px;
              color: #000;
              cursor: pointer;
            }
          }
          li:hover{
            span{
              color: #b80000;
              a{
                color: #b80000;
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/english/engleft/index.vue